// src/pages/FaleConosco.tsx
import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';

const WHATSAPP_MESSAGE = encodeURIComponent('Olá, vim do site e preciso de suporte');

const contatos = [
  {
    tipo: 'telefone',
    label: 'Telefone 1',
    valor: '(11) 2539-1686',
    href: 'tel:+551125391686',
    icon: <Phone className="w-6 h-6 text-blue-600" />,
    bg: 'bg-blue-100',
  },
  {
    tipo: 'telefone',
    label: 'Telefone 2',
    valor: '(11) 2539-1698',
    href: 'tel:+551125391698',
    icon: <Phone className="w-6 h-6 text-blue-600" />,
    bg: 'bg-blue-100',
  },
  {
    tipo: 'whatsapp',
    label: 'WhatsApp 1',
    valor: '(11) 99973-3976',
    href: `https://wa.me/5511999733976?text=${WHATSAPP_MESSAGE}`,
    icon: <MessageCircle className="w-6 h-6 text-green-600" />,
    bg: 'bg-green-100',
  },
  {
    tipo: 'whatsapp',
    label: 'WhatsApp 2',
    valor: '(11) 97387-1492',
    href: `https://wa.me/5511973871492?text=${WHATSAPP_MESSAGE}`,
    icon: <MessageCircle className="w-6 h-6 text-green-600" />,
    bg: 'bg-green-100',
  },
  {
    tipo: 'email',
    label: 'E-mail',
    valor: 'contato@federacaodoscabeleireiros.com.br',
    href: 'mailto:contato@federacaodoscabeleireiros.com.br',
    icon: <Mail className="w-6 h-6 text-purple-600" />,
    bg: 'bg-purple-100',
  },
];

const FaleConosco: React.FC = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold mb-3">Fale Conosco</h1>
        <p className="text-lg text-gray-600">
          Entre em contato pelos canais abaixo. Estamos aqui para ajudar!
        </p>
      </div>

      <div className="space-y-4">
        {contatos.map((item) => {
          const isClickable = item.tipo === 'whatsapp' || item.tipo === 'email' || item.tipo === 'telefone';
          const isWhatsapp = item.tipo === 'whatsapp';

          return (
            <a
              key={item.label}
              href={item.href}
              target={isWhatsapp ? '_blank' : undefined}
              rel={isWhatsapp ? 'noopener noreferrer' : undefined}
              className={`flex items-center gap-4 bg-white rounded-xl shadow-md p-5 transition-transform hover:scale-[1.02] hover:shadow-lg ${
                isClickable ? 'cursor-pointer' : ''
              }`}
            >
              <div className={`${item.bg} p-3 rounded-lg shrink-0`}>
                {item.icon}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-0.5">
                  {item.label}
                </p>
                <p className="font-semibold text-gray-800 truncate">{item.valor}</p>
              </div>

              {isWhatsapp && (
                <span className="shrink-0 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">
                  Abrir WhatsApp
                </span>
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default FaleConosco;